import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft } from 'lucide-react';

const CGVPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#E9DFCF' }} data-testid="cgv-page">
      <Header />
      
      <main className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-8">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-200">
            <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-8" style={{ letterSpacing: '-0.04em' }}>
              Conditions Générales de Vente
            </h1>

            <div className="prose prose-gray max-w-none">
              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 1 - Objet</h2>
              <p className="text-gray-600 mb-4">
                Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles 
                entre ACDC-Formation et ses clients pour toute prestation de formation professionnelle 
                ou de conseil.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 2 - Prestataire</h2>
              <p className="text-gray-600 mb-4">
                <strong>ACDC-Formation</strong><br />
                7 avenue Paul Cézanne, 83600 Cogolin<br />
                Téléphone : 06 78 26 91 10 / 07 69 05 76 73<br />
                Email : contact@acdc-formation.com
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 3 - Inscription et convention</h2>
              <p className="text-gray-600 mb-4">
                Toute inscription à une formation fait l'objet d'une convention de formation 
                professionnelle établie selon les dispositions légales en vigueur. Cette convention 
                précise les objectifs, le programme, la durée, les moyens pédagogiques et les 
                modalités de suivi et d'évaluation.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 4 - Tarifs et modalités de paiement</h2>
              <p className="text-gray-600 mb-4">
                Les prix sont indiqués en euros hors taxes. La TVA applicable sera ajoutée 
                conformément à la législation en vigueur. Le règlement s'effectue :
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Par virement bancaire</li>
                <li>Par chèque à l'ordre de ACDC-Formation</li>
                <li>Par prise en charge OPCO (sur justificatif d'accord)</li>
              </ul>
              <p className="text-gray-600 mb-4">
                Sauf accord particulier, le paiement est dû à réception de la facture.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 5 - Annulation et report</h2>
              <p className="text-gray-600 mb-4">
                <strong>Par le client :</strong>
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Annulation plus de 15 jours avant : remboursement intégral ou report gratuit</li>
                <li>Annulation entre 15 et 7 jours : 50% des frais de formation dus</li>
                <li>Annulation moins de 7 jours : 100% des frais de formation dus</li>
              </ul>
              <p className="text-gray-600 mb-4">
                <strong>Par ACDC-Formation :</strong> En cas de force majeure ou de nombre insuffisant 
                de participants, nous nous réservons le droit d'annuler ou reporter la formation. 
                Le client sera remboursé intégralement ou pourra reporter sa participation.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 6 - Déroulement des formations</h2>
              <p className="text-gray-600 mb-4">
                Les formations peuvent se dérouler :
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>En présentiel dans nos locaux ou ceux du client</li>
                <li>En distanciel via visioconférence</li>
                <li>En format hybride combinant les deux modalités</li>
              </ul>
              <p className="text-gray-600 mb-4">
                Les horaires, lieu et modalités pratiques sont précisés dans la convention.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 7 - Attestation et évaluation</h2>
              <p className="text-gray-600 mb-4">
                À l'issue de la formation, une attestation de fin de formation est remise au 
                participant mentionnant les objectifs, la nature, la durée et les résultats de 
                l'évaluation des acquis.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 8 - Propriété intellectuelle</h2>
              <p className="text-gray-600 mb-4">
                Les supports de formation remis aux participants sont la propriété intellectuelle 
                de ACDC-Formation. Toute reproduction, modification ou diffusion est interdite 
                sans autorisation écrite préalable.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 9 - Responsabilité</h2>
              <p className="text-gray-600 mb-4">
                ACDC-Formation s'engage à mettre en œuvre tous les moyens nécessaires à la 
                bonne exécution des prestations. Notre responsabilité ne pourra être engagée 
                qu'en cas de faute prouvée et sera limitée au montant de la prestation concernée.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 10 - Protection des données</h2>
              <p className="text-gray-600 mb-4">
                Les données personnelles collectées sont traitées conformément à notre{' '}
                <Link to="/confidentialite" className="text-blue-700 hover:underline">
                  politique de confidentialité
                </Link>{' '}
                et au RGPD.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 11 - Réclamation</h2>
              <p className="text-gray-600 mb-4">
                Toute réclamation doit être adressée par écrit à contact@acdc-formation.com 
                dans un délai de 30 jours suivant la prestation. Nous nous engageons à y 
                répondre dans un délai de 15 jours ouvrés.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">Article 12 - Droit applicable et litiges</h2>
              <p className="text-gray-600 mb-4">
                Les présentes CGV sont soumises au droit français. En cas de litige, une 
                solution amiable sera recherchée. À défaut, les tribunaux compétents seront 
                ceux du ressort du siège social de ACDC-Formation.
              </p>

              <p className="text-gray-500 text-sm mt-8">
                Dernière mise à jour : Février 2026
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CGVPage;
